<p class="hint">Last updated {{ vm.lastUpdated | timeFormat }}</p>

<section class="timeline flex flex-col gap-8 mt-12">
  @for (step of vm.claimTracker; track $index) {
    @if (step.currentStep) {
      <section class="current-step" [class.warning]="isWarning(step)">
        <app-tracker-current-step [step]="step" [claimType]="claimType()" [serviceOptionType]="vm.serviceOptionType" />
      </section>
    } @else if (step.futureStep) {
      <section class="future-step">
        <section class="heading">
          <i class="fa-light fa-circle-dashed"></i>
          <p class="body">{{ step.status | statusNameMapping }}</p>
        </section>
      </section>
    } @else {
      <section class="previous-step">
        <section class="connector"></section>
        <section class="heading">
          <i class="fa-light fa-circle-check"></i>
          <p class="body">{{ step.status | statusNameMapping }}</p>

          <p class="body">
            {{ step.statusChange | date: 'dd/MM/yy' }}
          </p>
        </section>
      </section>
    }
  }
</section>
